let state = {
  choices: null
};

export default state;
